import { useTheme } from "@/contexts/theme";
import { HpLogsIcon } from "@/themes/hp-client/icons/HpLogsIcon";

const LoggerIcon = (props: any) => {
  const color = props.color || "#8283BE";
  const { currentTheme } = useTheme();
  const isHpClient = currentTheme === "hp-client";
  if (isHpClient) {
    return <HpLogsIcon />;
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.3335 13H14.0002"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.3335 8.33331H14.0002"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.3335 3.66669H14.0002"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 3.66665L2.66667 4.33331L4.66667 2.33331"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 8.33333L2.66667 9L4.66667 7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 13L2.66667 13.6667L4.66667 11.6667"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { LoggerIcon };
